// Centralized feature tags and product-to-feature mappings
export const FeatureTags = {
  // Charts
  CHARTS: 'FEATURE_CHARTS',

  // Indicators
  STANDARD_INDICATORS: 'FEATURE_STANDARD_INDICATORS',
  DTU_INDICATORS: 'FEATURE_DTU_INDICATORS',
  CUSTOM_INDICATORS: 'FEATURE_CUSTOM_INDICATORS',

  // Backtests
  SHOWCASE: 'FEATURE_SHOWCASE',
  BACKTEST_SETTINGS: 'FEATURE_BACKTEST_SETTINGS',
  BACKTEST_INSIGHTS: 'FEATURE_BACKTEST_INSIGHTS',
  FEATURED_BACKTESTS: 'FEATURE_FEATURED_BACKTESTS',

  // Pattern Builder
  PATTERN_BUILDER: 'FEATURE_PATTERN_BUILDER',
  PRIVATE_PATTERNS: 'FEATURE_PRIVATE_PATTERNS',

  // Alerts
  ALERTS: 'FEATURE_ALERTS',
  ALERT_CREATE: 'FEATURE_ALERT_CREATE',
  RESTRICTED_ALERT_TIMEFRAMES: 'FEATURE_RESTRICTED_ALERT_TIMEFRAMES',
  AUTOTRADING: 'FEATURE_AUTOTRADING',
  MANAGE_TRADING_ACCOUNTS: 'FEATURE_MANAGE_TRADING_ACCOUNTS',

  // Misc
  CAN_TOGGLE_TRADING_HOUSE: 'FEATURE_CAN_TOGGLE_TRADING_HOUSE',
} as const

export type FeatureTag = (typeof FeatureTags)[keyof typeof FeatureTags]

export const ALL_FEATURE_TAGS: FeatureTag[] = Object.values(FeatureTags)

export const isActiveStatus = (status?: string): boolean => {
  const s = status?.toLowerCase().trim()
  return s === 'member' || s === 'trial' || s === 'free'
}
